import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createBlock as _createBlock, unref as _unref, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
    class: "nav nav-underline mb-3",
    role: "tablist"
};
const _hoisted_2 = {
    class: "nav-item",
    role: "presentation"
};
const _hoisted_3 = ["id", "data-bs-target", "aria-controls"];
const _hoisted_4 = { class: "tab-content mb-4" };
const _hoisted_5 = ["id", "aria-labelledby"];
const _hoisted_6 = { class: "mb-4" };
const _hoisted_7 = { class: "row" };
const _hoisted_8 = { class: "col-lg-3 col-12" };
const _hoisted_9 = ["onSubmit"];
const _hoisted_10 = { class: "form-check mb-3" };
const _hoisted_11 = ["id", "onUpdate:modelValue"];
const _hoisted_12 = ["for"];
const _hoisted_13 = { class: "form-floating mb-3" };
const _hoisted_14 = ["id", "onUpdate:modelValue"];
const _hoisted_15 = ["for"];
const _hoisted_16 = { class: "form-floating mb-3" };
const _hoisted_17 = ["id", "onUpdate:modelValue"];
const _hoisted_18 = ["for"];
const _hoisted_19 = { class: "form-floating" };
const _hoisted_20 = ["id", "onUpdate:modelValue"];
const _hoisted_21 = ["for"];
const _hoisted_22 = { class: "form-floating mb-3" };
const _hoisted_23 = ["onInput", "id"];
const _hoisted_24 = ["for"];
const _hoisted_25 = { class: "form-floating mb-3" };
const _hoisted_26 = ["id", "onUpdate:modelValue"];
const _hoisted_27 = ["for"];
const _hoisted_28 = { class: "col-lg-3 col-12" };
const _hoisted_29 = { class: "d-flex align-items-center justify-content-center" };
const _hoisted_30 = ["src"];
const _hoisted_31 = {
    key: 1,
    class: "spinner-border text-primary mt-5",
    role: "status"
};
const _hoisted_32 = { class: "col-lg-6 col-12" };
const _hoisted_33 = ["onClick"];
const _hoisted_34 = {
    class: "modal fade",
    id: "createVariant",
    tabindex: "-1",
    "aria-labelledby": "createVariantModalLabel",
    "aria-hidden": "true"
};
const _hoisted_35 = { class: "modal-dialog modal-dialog-centered modal-lg" };
const _hoisted_36 = { class: "modal-content" };
const _hoisted_37 = { class: "modal-body" };
const _hoisted_38 = { class: "form-floating mb-3" };
const _hoisted_39 = { class: "form-floating" };
const _hoisted_40 = { class: "form-floating mb-3" };
import { FilterMatchMode } from '@primevue/core/api';
import { router, useForm } from '@inertiajs/vue3';
import { onMounted, ref } from 'vue';
import { formatters } from '@/Composables/formatters';
import { responseMessages } from '@/Composables/responseMessages';
import { useConfirm } from 'primevue';
import ProductPriceOption from '@/Tenant/Components/ProductPriceOption.vue';
import { Modal } from 'bootstrap';
import VariantComponents from './VariantComponents.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Variants',
    props: {
        lid: Object
    },
    emits: ['update'],
    setup(__props, { emit: __emit }) {
        let { showPageFlashMessage, showErrorMessage } = responseMessages();
        let { formatCurrency, formatDate } = formatters();
        const props = __props;
        const emit = __emit;
        const variantComponentsKey = ref(0);
        const tableFilter = ref({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
        const confirm = useConfirm();
        const createVariantForm = useForm({
            name: null,
            configImgTopFile: null,
            configTopColor: null
        });
        const variants = ref(props.lid?.variants ?? []);
        const loading = ref(true);
        const createVariantModal = ref(null);
        onMounted(() => {
            const modalElement = document.getElementById('createVariant');
            if (modalElement) {
                createVariantModal.value = new Modal(modalElement);
            }
            setTimeout(() => {
                loading.value = false;
            }, 1000);
        });
        function create() {
            if (props.lid == null) {
                return;
            }
            createVariantForm.transform((data) => ({
                name: data.name,
                config_img_top_file: data.configImgTopFile,
                config_top_color: data.configTopColor,
            }))
                .submit('post', route('admin.lids.variants.store', props.lid.uuid), {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                    createVariantModal.value?.hide();
                    emit('update');
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function update(variant) {
            router.post(route('admin.lids.variants.update', variant.uuid), {
                name: variant.name,
                name_en: variant.nameEn,
                config_img_top_file: variant.configImgTopFile,
                config_top_color: variant.configTopColor,
                delivery_days: variant.deliveryDays,
                active: variant.active ? 1 : 0
            }, {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                    emit('update');
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function remove(variant) {
            confirm.require({
                message: 'Soll die Variante wirklich gelöscht werden?',
                header: 'Variante löschen?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    router.delete(route('admin.lids.variants.destroy', variant.uuid), {
                        preserveScroll: true,
                        onSuccess: page => {
                            showPageFlashMessage(page);
                            emit('update');
                        },
                        onError: errors => {
                            console.log(errors);
                            showErrorMessage(errors[0]);
                        }
                    });
                },
                reject: () => {
                    confirm.close();
                }
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _cache[17] || (_cache[17] = _createElementVNode("button", {
                    class: "btn btn-secondary d-inline-flex align-items-center mb-4",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#createVariant"
                }, [
                    _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "16",
                        height: "16",
                        fill: "currentColor",
                        class: "bi bi-plus-lg",
                        viewBox: "0 0 16 16"
                    }, [
                        _createElementVNode("path", {
                            "fill-rule": "evenodd",
                            d: "M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"
                        })
                    ]),
                    _createElementVNode("span", { class: "ms-2" }, "Neue Variante")
                ], -1)),
                _createElementVNode("ul", _hoisted_1, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(variants.value, (variant, index) => {
                        return (_openBlock(), _createElementBlock("li", _hoisted_2, [
                            _createElementVNode("button", {
                                class: _normalizeClass(["nav-link", { active: Number(index) == 0 }]),
                                id: 'variant-tab' + index,
                                "data-bs-toggle": "tab",
                                "data-bs-target": '#variant-tab-pane' + index,
                                type: "button",
                                role: "tab",
                                "aria-controls": 'variant-tab-pane' + index,
                                "aria-selected": "true"
                            }, _toDisplayString(index + 1) + ". Variante", 11, _hoisted_3)
                        ]));
                    }), 256))
                ]),
                _createElementVNode("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(variants.value, (variant, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass(["tab-pane fade", { 'show active': Number(index) == 0 }]),
                            id: 'variant-tab-pane' + index,
                            role: "tabpanel",
                            "aria-labelledby": 'variant-tab' + index,
                            tabindex: "0"
                        }, [
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("div", _hoisted_8, [
                                        _createElementVNode("form", {
                                            onSubmit: _withModifiers(($event) => (update(variant)), ["prevent"])
                                        }, [
                                            _createElementVNode("div", _hoisted_10, [
                                                _withDirectives(_createElementVNode("input", {
                                                    class: "form-check-input",
                                                    type: "checkbox",
                                                    value: "1",
                                                    id: 'active' + index,
                                                    "onUpdate:modelValue": ($event) => ((variant.active) = $event)
                                                }, null, 8, _hoisted_11), [
                                                    [_vModelCheckbox, variant.active]
                                                ]),
                                                _createElementVNode("label", {
                                                    class: "form-check-label",
                                                    for: 'active' + index
                                                }, "Aktiv (Variante kann konfiguriert werden)", 8, _hoisted_12)
                                            ]),
                                            _createElementVNode("div", _hoisted_13, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: 'variantName' + index,
                                                    "onUpdate:modelValue": ($event) => ((variant.name) = $event),
                                                    required: ""
                                                }, null, 8, _hoisted_14), [
                                                    [_vModelText, variant.name]
                                                ]),
                                                _createElementVNode("label", {
                                                    for: 'variantName' + index
                                                }, "Name", 8, _hoisted_15)
                                            ]),
                                            _createElementVNode("div", _hoisted_16, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: 'variantNameEn' + index,
                                                    "onUpdate:modelValue": ($event) => ((variant.nameEn) = $event)
                                                }, null, 8, _hoisted_17), [
                                                    [_vModelText, variant.nameEn]
                                                ]),
                                                _createElementVNode("label", {
                                                    for: 'variantNameEn' + index
                                                }, "Name (en)", 8, _hoisted_18)
                                            ]),
                                            _createElementVNode("div", _hoisted_19, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: 'variantConfigTopColor' + index,
                                                    "onUpdate:modelValue": ($event) => ((variant.configTopColor) = $event)
                                                }, null, 8, _hoisted_20), [
                                                    [_vModelText, variant.configTopColor]
                                                ]),
                                                _createElementVNode("label", {
                                                    for: 'variantConfigTopColor' + index
                                                }, "Farbcode (HEX)", 8, _hoisted_21)
                                            ]),
                                            _cache[5] || (_cache[5] = _createElementVNode("p", { class: "form-text mb-3" }, "Nur relevant, wenn kein Konfigurations-Bild vorliegt. Ersatz für die Konfigurations-Vorschau.", -1)),
                                            _createElementVNode("div", _hoisted_22, [
                                                _createElementVNode("input", {
                                                    type: "file",
                                                    onInput: ($event) => (variant.configImgTopFile = $event.target.files[0]),
                                                    class: "form-control",
                                                    id: 'variantConfigImgTopFile' + index
                                                }, null, 40, _hoisted_23),
                                                _createElementVNode("label", {
                                                    for: 'variantConfigImgTopFile' + index
                                                }, "Konfigurations-Datei", 8, _hoisted_24)
                                            ]),
                                            _createElementVNode("div", _hoisted_25, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "number",
                                                    class: "form-control",
                                                    id: 'deliveryDays' + index,
                                                    "onUpdate:modelValue": ($event) => ((variant.deliveryDays) = $event),
                                                    min: "1",
                                                    step: "1"
                                                }, null, 8, _hoisted_26), [
                                                    [_vModelText, variant.deliveryDays]
                                                ]),
                                                _createElementVNode("label", {
                                                    for: 'deliveryDays' + index
                                                }, "Lieferzeit in Tagen", 8, _hoisted_27)
                                            ]),
                                            _cache[6] || (_cache[6] = _createElementVNode("button", {
                                                type: "submit",
                                                class: "btn btn-success d-inline-flex align-items-center"
                                            }, [
                                                _createElementVNode("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    width: "16",
                                                    height: "16",
                                                    fill: "currentColor",
                                                    class: "bi bi-check2",
                                                    viewBox: "0 0 16 16"
                                                }, [
                                                    _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                                ]),
                                                _createElementVNode("span", { class: "ms-2" }, "Speichern")
                                            ], -1))
                                        ], 40, _hoisted_9)
                                    ]),
                                    _createElementVNode("div", _hoisted_28, [
                                        _cache[8] || (_cache[8] = _createElementVNode("h4", { class: "bg-primary text-white px-3 py-2 mb-4" }, "Konfigurations-Bild", -1)),
                                        _createElementVNode("div", _hoisted_29, [
                                            (!loading.value)
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 0,
                                                    src: variant.configImgTopFileUrl,
                                                    alt: "Konfigurations-Bild",
                                                    style: { "height": "200px", "max-width": "100%" }
                                                }, null, 8, _hoisted_30))
                                                : _createCommentVNode("", true),
                                            (loading.value)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [...(_cache[7] || (_cache[7] = [
                                                        _createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
                                                    ]))]))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_32, [
                                        _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "fw-bold bg-primary text-white mb-4 px-3 py-2" }, "Varianten-Preise", -1)),
                                        _createVNode(ProductPriceOption, {
                                            lidVariant: variant,
                                            priceBundleUuid: variant.priceBundleUuid
                                        }, null, 8, ["lidVariant", "priceBundleUuid"])
                                    ])
                                ]),
                                (variant.canRemove)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "btn btn-danger d-inline-flex align-items-center mt-4",
                                        onClick: ($event) => (remove(variant))
                                    }, [...(_cache[10] || (_cache[10] = [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                fill: "currentColor",
                                                class: "bi bi-x-circle",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" }),
                                                _createElementVNode("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" })
                                            ], -1),
                                            _createElementVNode("span", { class: "ms-2" }, "Variante löschen", -1)
                                        ]))], 8, _hoisted_33))
                                    : _createCommentVNode("", true)
                            ]),
                            (_openBlock(), _createBlock(VariantComponents, {
                                lidVariant: variant,
                                key: variantComponentsKey.value,
                                onUpdate: _cache[0] || (_cache[0] = ($event) => (variantComponentsKey.value++))
                            }, null, 8, ["lidVariant"]))
                        ], 10, _hoisted_5));
                    }), 256))
                ]),
                (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                    _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("div", _hoisted_36, [
                                _cache[16] || (_cache[16] = _createElementVNode("div", { class: "modal-header" }, [
                                    _createElementVNode("h1", {
                                        class: "modal-title fs-5 fw-bold",
                                        id: "createVariantModalLabel"
                                    }, "Neue Variante"),
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn-close",
                                        "data-bs-dismiss": "modal",
                                        "aria-label": "Close"
                                    })
                                ], -1)),
                                _createElementVNode("form", {
                                    onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event) => (create()), ["prevent"]))
                                }, [
                                    _createElementVNode("div", _hoisted_37, [
                                        _createElementVNode("div", _hoisted_38, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                id: "name",
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(createVariantForm).name) = $event)),
                                                required: ""
                                            }, null, 512), [
                                                [_vModelText, _unref(createVariantForm).name]
                                            ]),
                                            _cache[11] || (_cache[11] = _createElementVNode("label", { for: "name" }, "Name", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_39, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                id: "configTopColor",
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(createVariantForm).configTopColor) = $event))
                                            }, null, 512), [
                                                [_vModelText, _unref(createVariantForm).configTopColor]
                                            ]),
                                            _cache[12] || (_cache[12] = _createElementVNode("label", { for: "configTopColor" }, "Farbcode (HEX)", -1))
                                        ]),
                                        _cache[14] || (_cache[14] = _createElementVNode("p", { class: "form-text mb-3" }, "Nur relevant, wenn kein Konfigurations-Bild vorliegt. Ersatz für die Konfigurations-Vorschau.", -1)),
                                        _createElementVNode("div", _hoisted_40, [
                                            _createElementVNode("input", {
                                                type: "file",
                                                onInput: _cache[3] || (_cache[3] = ($event) => (_unref(createVariantForm).configImgTopFile = $event.target.files[0])),
                                                class: "form-control",
                                                id: "configImgTopFile",
                                                required: ""
                                            }, null, 32),
                                            _cache[13] || (_cache[13] = _createElementVNode("label", { for: "configImgTopFile" }, "Konfigurations-Datei", -1))
                                        ])
                                    ]),
                                    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "modal-footer" }, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn-secondary",
                                            "data-bs-dismiss": "modal"
                                        }, "Abbrechen"),
                                        _createElementVNode("button", {
                                            type: "submit",
                                            class: "btn btn-success d-inline-flex align-items-center"
                                        }, [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                fill: "currentColor",
                                                class: "bi bi-check2",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                            ]),
                                            _createElementVNode("span", { class: "ms-2" }, "Speichern")
                                        ])
                                    ], -1))
                                ], 32)
                            ])
                        ])
                    ])
                ]))
            ], 64));
        };
    }
});
